export default __webpack_public_path__ + "static/media/Prince Edward Island - Logo.c329ddd0.png";